/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable jsx-a11y/anchor-is-valid */
export default function SLA() {
  return (
    <>
      <div className="rts-hosting-banner rts-hosting-banner-bg banner-default-height">
        <div className="container">
          <div className="row">
            <div className="banner-area">
              <div className="rts-hosting-banner rts-hosting-banner__content about__banner">
                <span
                  className="starting__price sal-animate"
                  data-sal="slide-down"
                  data-sal-delay={100}
                  data-sal-duration={800}
                >
                  SLA
                </span>
                <h1
                  className="banner-title sal-animate"
                  data-sal="slide-down"
                  data-sal-delay={200}
                  data-sal-duration={800}
                >
                  Cam kết chất lượng dịch vụ
                </h1>
                <p
                  className="slogan sal-animate"
                  data-sal="slide-down"
                  data-sal-delay={300}
                  data-sal-duration={800}
                >
                  Chúng tôi đảm bảo dịch vụ của Quý khách đang sử dụng đạt
                  uptime từ 99,99% trở lên.
                </p>
                <div
                  className="hosting-action sal-animate"
                  data-sal="slide-down"
                  data-sal-delay={200}
                  data-sal-duration={800}
                >
                  <a
                    href=""
                    className="btn__two secondary__bg secondary__color"
                  >
                    Xem thêm <i className="fa-regular fa-arrow-right" />
                  </a>
                </div>
              </div>
              <div className="rts-hosting-banner__image about">
                <img
                  src="assets/images/banner/banner-hero-about.png"
                  width={562}
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="rts-why-transfer section__padding">
        <div className="container">
          <div className="row justify-content-center">
            <div className="rts-section w-670 text-center">
              <h2
                className="rts-section__title sal-animate"
                data-sal="slide-down"
                data-sal-delay={100}
                data-sal-duration={800}
              >
                Tỷ lệ hoạt động hàng tháng của máy chủ ảo là từ 99,9% trở lên
              </h2>
            </div>
          </div>
          {/* content */}
          <div className="row justify-content-sm-center justify-content-md-start g-30">
            <div className="col-lg-6 col-md-6 col-sm-10">
              <div className="card-feature ">
                <div className="card-feature__single">
                  <div className="card-feature__single--icon">
                    <svg
                      width={40}
                      height={40}
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M34.1172 4.65781H30.5008V2.35C30.5008 1.05469 29.4469 0 28.1508 0C26.8547 0 25.8008 1.05391 25.8008 2.35V4.65781H14.2016V2.35C14.2016 1.05469 13.1484 0 11.8539 0C10.5586 0 9.50391 1.05391 9.50391 2.35V4.65781H5.88594C3.26328 4.65781 1.12891 6.79141 1.12891 9.41484V35.243C1.12891 37.8656 3.2625 40 5.88594 40H34.1172C36.7398 40 38.8742 37.8664 38.8742 35.243V9.41406C38.8742 6.79141 36.7398 4.65781 34.1172 4.65781ZM27.0508 2.35C27.0508 1.74297 27.5445 1.24922 28.1516 1.24922C28.7586 1.24922 29.2523 1.74297 29.2523 2.35V8.21406C29.2523 8.82109 28.7586 9.31484 28.1516 9.31484C27.5445 9.31484 27.0508 8.82109 27.0508 8.21406V2.35ZM10.7539 2.35C10.7539 1.74297 11.2477 1.24922 11.8547 1.24922C12.4602 1.24922 12.9531 1.74297 12.9531 2.35V8.21406C12.9531 8.82109 12.4602 9.31484 11.8547 9.31484C11.2477 9.31484 10.7539 8.82109 10.7539 8.21406V2.35ZM5.88594 5.90625H9.50469V8.21406C9.50469 9.50937 10.5586 10.5641 11.8547 10.5641C13.1492 10.5641 14.2023 9.51016 14.2023 8.21406V5.90625H25.8023V8.21406C25.8023 9.50937 26.8563 10.5641 28.1523 10.5641C29.4484 10.5641 30.5023 9.51016 30.5023 8.21406V5.90625H34.1188C36.0531 5.90625 37.6266 7.47969 37.6266 9.41406V13.4531H2.37813V9.41406C2.37813 7.48047 3.95156 5.90625 5.88594 5.90625ZM34.1172 38.7508H5.88594C3.95156 38.7508 2.37813 37.1773 2.37813 35.243V14.7031H37.625V35.243C37.625 37.1773 36.0516 38.7508 34.1172 38.7508ZM9.50703 19.482H7.60625C6.60156 19.482 5.78359 20.3 5.78359 21.3047V23.2047C5.78359 24.2094 6.60156 25.0273 7.60625 25.0273H9.50625C10.5109 25.0273 11.3289 24.2094 11.3289 23.2047V21.3047C11.3297 20.2992 10.5117 19.482 9.50703 19.482ZM10.0805 23.2047C10.0805 23.5211 9.82344 23.7781 9.50703 23.7781H7.60625C7.29531 23.7781 7.03281 23.5156 7.03281 23.2047V21.3047C7.03281 20.9883 7.28984 20.7312 7.60625 20.7312H9.50625C9.82266 20.7312 10.0797 20.9883 10.0797 21.3047V23.2047H10.0805ZM20.9516 19.482H19.0539C18.0477 19.482 17.2289 20.3 17.2289 21.3047V23.2047C17.2289 24.2094 18.0477 25.0273 19.0539 25.0273H20.9516C21.9563 25.0273 22.7742 24.2094 22.7742 23.2047V21.3047C22.7742 20.2992 21.9563 19.482 20.9516 19.482ZM21.525 23.2047C21.525 23.5211 21.268 23.7781 20.9516 23.7781H19.0539C18.7414 23.7781 18.4781 23.5156 18.4781 23.2047V21.3047C18.4781 20.9883 18.7367 20.7312 19.0539 20.7312H20.9516C21.268 20.7312 21.525 20.9883 21.525 21.3047V23.2047ZM32.3969 19.482H30.4992C29.493 19.482 28.6742 20.3 28.6742 21.3047V23.2047C28.6742 24.2094 29.493 25.0273 30.4992 25.0273H32.3969C33.4031 25.0273 34.2219 24.2094 34.2219 23.2047V21.3047C34.2211 20.2992 33.4023 19.482 32.3969 19.482ZM32.9727 23.2047C32.9727 23.5156 32.7086 23.7781 32.3969 23.7781H30.4992C30.1867 23.7781 29.9234 23.5156 29.9234 23.2047V21.3047C29.9234 20.9883 30.182 20.7312 30.4992 20.7312H32.3969C32.7141 20.7312 32.9727 20.9883 32.9727 21.3047V23.2047ZM9.50703 28.4266H7.60625C6.60156 28.4266 5.78359 29.2453 5.78359 30.2516V32.1492C5.78359 33.1539 6.60156 33.9719 7.60625 33.9719H9.50625C10.5109 33.9719 11.3289 33.1539 11.3289 32.1492V30.2516C11.3297 29.2453 10.5117 28.4266 9.50703 28.4266ZM10.0805 32.1492C10.0805 32.4656 9.82344 32.7227 9.50703 32.7227H7.60625C7.28984 32.7227 7.03281 32.4656 7.03281 32.1492V30.2516C7.03281 29.9391 7.29531 29.6758 7.60625 29.6758H9.50625C9.82266 29.6758 10.0797 29.9344 10.0797 30.2516V32.1492H10.0805ZM20.9516 28.4266H19.0539C18.0477 28.4266 17.2289 29.2453 17.2289 30.2516V32.1492C17.2289 33.1539 18.0477 33.9719 19.0539 33.9719H20.9516C21.9563 33.9719 22.7742 33.1539 22.7742 32.1492V30.2516C22.7742 29.2453 21.9563 28.4266 20.9516 28.4266ZM21.525 32.1492C21.525 32.4656 21.268 32.7227 20.9516 32.7227H19.0539C18.7367 32.7227 18.4781 32.4656 18.4781 32.1492V30.2516C18.4781 29.9344 18.7367 29.6758 19.0539 29.6758H20.9516C21.268 29.6758 21.525 29.9344 21.525 30.2516V32.1492ZM32.3969 28.4266H30.4992C29.493 28.4266 28.6742 29.2453 28.6742 30.2516V32.1492C28.6742 33.1539 29.493 33.9719 30.4992 33.9719H32.3969C33.4031 33.9719 34.2219 33.1539 34.2219 32.1492V30.2516C34.2211 29.2453 33.4023 28.4266 32.3969 28.4266ZM32.9727 32.1492C32.9727 32.4656 32.7141 32.7227 32.3969 32.7227H30.4992C30.182 32.7227 29.9234 32.4656 29.9234 32.1492V30.2516C29.9234 29.9344 30.182 29.6758 30.4992 29.6758H32.3969C32.7141 29.6758 32.9727 29.9344 32.9727 30.2516V32.1492Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <h5 className="card-feature__single--title">
                    100% Host Node Uptime
                  </h5>
                  <p className="card-feature__single--description">
                    Nền tảng phần cứng lưu trữ các phiên bản máy tính của bạn
                    được thiết kế với mục tiêu chính là ổn định. Đồng thời, nhóm
                    kỹ sư của chúng tôi sử dụng giám sát tích cực để chủ động
                    phát hiện các vấn đề và thực hiện các biện pháp phòng ngừa,
                    giảm thiểu bất kỳ tác động nào khi phần cứng máy chủ bị lỗi.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-10">
              <div className="card-feature ">
                <div className="card-feature__single">
                  <div className="card-feature__single--icon">
                    <svg
                      width={40}
                      height={40}
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_852_1427)">
                        <path
                          d="M23.908 25.2068C24.4031 25.2068 24.8661 25.0117 25.2118 24.6573L28.283 21.5085C28.9839 20.7898 28.9694 19.6348 28.2506 18.9338C27.5317 18.2329 26.3765 18.2474 25.6756 18.9661L23.8739 20.8132L23.5583 20.5063C22.8385 19.8066 21.6833 19.8226 20.9832 20.5424C20.2834 21.2621 20.2996 22.4171 21.0194 23.1171L22.6386 24.6914C22.9804 25.0238 23.4313 25.2068 23.908 25.2068ZM21.8253 21.361C22.074 21.1052 22.4844 21.0999 22.7398 21.3482L23.4757 22.0638C23.7078 22.2896 24.0791 22.2846 24.3053 22.0528L26.5163 19.786C26.7653 19.5307 27.1756 19.5257 27.4307 19.7745C27.686 20.0235 27.6911 20.4336 27.4423 20.6889L24.3711 23.8375C24.1338 24.0914 23.7014 24.0967 23.4573 23.8497L21.8381 22.2753C21.5825 22.0267 21.5767 21.6165 21.8253 21.361Z"
                          fill="#2D3C58"
                        />
                        <path
                          d="M19.3675 25.6064C19.1722 25.3475 18.8041 25.296 18.5451 25.4913C18.2862 25.6866 18.2348 26.0547 18.43 26.3136C18.6438 26.5969 18.8804 26.8686 19.1329 27.1211C20.5766 28.5646 22.496 29.3596 24.5377 29.3596C26.5793 29.3596 28.4987 28.5646 29.9423 27.1211C31.3861 25.6777 32.1811 23.7585 32.1811 21.7171C32.1811 19.6757 31.386 17.7566 29.9423 16.3132C26.9621 13.3334 22.1131 13.3335 19.1329 16.3132C17.1011 18.3446 16.3821 21.3082 17.2566 24.0472C17.3552 24.3561 17.6858 24.5264 17.9944 24.428C18.3034 24.3294 18.4739 23.999 18.3752 23.6902C17.635 21.3716 18.2435 18.863 19.9634 17.1435C22.4855 14.6215 26.5898 14.6215 29.1119 17.1435C30.3338 18.3652 31.0068 19.9895 31.0068 21.7172C31.0068 23.445 30.3338 25.0693 29.1119 26.291C27.8902 27.5126 26.2656 28.1855 24.5377 28.1855C22.8098 28.1855 21.1852 27.5127 19.9633 26.291C19.7491 26.0766 19.5486 25.8464 19.3675 25.6064Z"
                          fill="#2D3C58"
                        />
                        <path
                          d="M39.1923 32.443L35.488 28.7392C35.2586 28.51 34.8869 28.5099 34.6575 28.7392L34.6348 28.7619L33.2093 27.3366C34.1676 25.8592 34.7385 24.1523 34.8509 22.3708C34.8713 22.0472 34.6254 21.7684 34.3018 21.7479C33.9784 21.7282 33.6994 21.9734 33.6788 22.2969C33.5386 24.521 32.5924 26.6148 31.0146 28.1923C29.2315 29.9753 26.8898 30.8678 24.5475 30.8701C24.5445 30.87 24.5416 30.8696 24.5386 30.8696H24.492C22.1623 30.8579 19.8362 29.9657 18.0626 28.1923C16.3327 26.4628 15.3801 24.1632 15.3801 21.7172C15.3801 19.2712 16.3327 16.9716 18.0626 15.242C21.6334 11.6716 27.4438 11.6716 31.0146 15.242C32.3446 16.5719 33.2223 18.2493 33.5528 20.0931C33.6101 20.4123 33.9154 20.6243 34.2344 20.5674C34.5536 20.5102 34.7659 20.2052 34.7088 19.8859C34.3356 17.8049 33.3454 15.912 31.845 14.4117C31.1016 13.6684 30.2719 13.0627 29.388 12.5937V7.86195C29.3876 7.70742 29.3252 7.55617 29.2161 7.4468L21.9403 0.171953C21.8309 0.0630469 21.6797 0.000390625 21.525 0H1.76156C0.790313 0 7.8125e-05 0.790078 7.8125e-05 1.76125V6.69586C7.8125e-05 7.02008 0.262891 7.28297 0.587266 7.28297C0.911563 7.28297 1.17445 7.02016 1.17445 6.69586V1.76125C1.17445 1.4375 1.43781 1.17414 1.76164 1.17414H20.938V6.68781C20.938 7.65898 21.7283 8.44906 22.6995 8.44906H28.2139V12.062C27.0683 11.6279 25.8605 11.4049 24.6507 11.3919C24.6449 11.3911 24.6393 11.3899 24.6333 11.3899H11.5239C11.1996 11.3899 10.9367 11.6528 10.9367 11.977C10.9367 12.3013 11.1996 12.5641 11.5239 12.5641H19.7447C18.9071 13.0021 18.1176 13.5627 17.4026 14.2458H11.5239C11.1996 14.2458 10.9367 14.5087 10.9367 14.8329C10.9367 15.1571 11.1996 15.42 11.5239 15.42H16.3458C15.3873 16.6615 14.7323 18.0913 14.4188 19.6177H11.524C11.1997 19.6177 10.9368 19.8805 10.9368 20.2048C10.9368 20.529 11.1997 20.7919 11.524 20.7919H14.2473C14.2203 21.0979 14.206 21.4065 14.206 21.7173C14.206 21.9723 14.2153 22.2259 14.2335 22.4777H11.5241C11.1998 22.4777 10.9369 22.7406 10.9369 23.0648C10.9369 23.3891 11.1998 23.652 11.5241 23.652H14.3866C14.686 25.2411 15.3537 26.7302 16.3476 28.0168H11.5241C11.1998 28.0168 10.9369 28.2796 10.9369 28.6039C10.9369 28.9282 11.1998 29.191 11.5241 29.191H17.4049C18.1189 29.8728 18.9072 30.4325 19.7433 30.8699H11.5238C11.1995 30.8699 10.9366 31.1328 10.9366 31.457C10.9366 31.7812 11.1995 32.0441 11.5238 32.0441H24.5386C25.7856 32.044 27.0327 31.82 28.2138 31.3726V38.2391C28.2138 38.5627 27.9504 38.8262 27.6266 38.8262H1.76156C1.43781 38.8262 1.17438 38.5628 1.17438 38.2391V9.04453C1.17438 8.72031 0.911484 8.45742 0.587187 8.45742C0.262891 8.45742 0 8.72023 0 9.04453V38.2391C7.8125e-05 39.2099 0.790313 40 1.76156 40H27.6266C28.5979 40 29.3881 39.2099 29.3881 38.2388V30.8405C29.6502 30.7015 29.9073 30.5502 30.159 30.3871L31.5842 31.8121C31.3376 32.0274 31.3244 32.4377 31.5615 32.6651L35.2659 36.369C36.2992 37.4459 38.1589 37.4459 39.1922 36.369C40.2694 35.3357 40.2693 33.4762 39.1923 32.443ZM22.6995 7.27492C22.3757 7.27492 22.1123 7.01156 22.1123 6.68781V2.00445L27.3834 7.27492H22.6995ZM31.1168 29.6842C31.3673 29.4771 31.6106 29.257 31.845 29.0227C32.078 28.7897 32.2984 28.5465 32.5066 28.2945L33.8044 29.5921L32.4145 30.9817L31.1168 29.6842ZM38.3619 35.5387C37.7656 36.1602 36.6926 36.16 36.0963 35.5387L32.807 32.2499L35.0727 29.9845L38.362 33.2733C38.9834 33.8696 38.9834 34.9424 38.3619 35.5387Z"
                          fill="#2D3C58"
                        />
                        <path
                          d="M5.32898 16.0002H7.89773C8.62195 16.0002 9.21117 15.4111 9.21117 14.6871V12.1186C9.21117 11.3945 8.62203 10.8054 7.89773 10.8054H5.32898C4.60484 10.8054 4.01562 11.3945 4.01562 12.1186V14.6871C4.01562 15.4111 4.60484 16.0002 5.32898 16.0002ZM5.19 12.1186C5.19 12.042 5.25242 11.9796 5.32898 11.9796H7.89773C7.97445 11.9796 8.0368 12.042 8.0368 12.1186V14.6871C8.0368 14.7637 7.97437 14.826 7.89773 14.826H5.32898C5.25234 14.826 5.19 14.7637 5.19 14.6871V12.1186Z"
                          fill="#2D3C58"
                        />
                        <path
                          d="M4.01562 22.9189C4.01562 23.643 4.60477 24.232 5.32898 24.232H7.89773C8.62195 24.232 9.21117 23.643 9.21117 22.9189V20.3505C9.21117 19.6264 8.62203 19.0374 7.89773 19.0374H5.32898C4.60484 19.0374 4.01562 19.6264 4.01562 20.3505V22.9189ZM5.19 20.3505C5.19 20.2738 5.25242 20.2115 5.32898 20.2115H7.89773C7.97445 20.2115 8.0368 20.2738 8.0368 20.3505V22.9189C8.0368 22.9956 7.97437 23.0579 7.89773 23.0579H5.32898C5.25234 23.0579 5.19 22.9956 5.19 22.9189V20.3505Z"
                          fill="#2D3C58"
                        />
                        <path
                          d="M4.01562 31.3179C4.01562 32.042 4.60477 32.631 5.32898 32.631H7.89773C8.62195 32.631 9.21117 32.042 9.21117 31.3179V28.7495C9.21117 28.0253 8.62203 27.4363 7.89773 27.4363H5.32898C4.60484 27.4363 4.01562 28.0253 4.01562 28.7495V31.3179ZM5.19 28.7495C5.19 28.6728 5.25242 28.6105 5.32898 28.6105H7.89773C7.97445 28.6105 8.0368 28.6728 8.0368 28.7495V31.3179C8.0368 31.3946 7.97437 31.4569 7.89773 31.4569H5.32898C5.25234 31.4569 5.19 31.3946 5.19 31.3179V28.7495Z"
                          fill="#2D3C58"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_852_1427">
                          <rect width={40} height={40} fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <h5 className="card-feature__single--title">
                    100% Network Uptime
                  </h5>
                  <p className="card-feature__single--description">
                    Sử dụng kiến trúc dự phòng và định tuyến BGP thông minh,
                    mạng lõi định tuyến một cách thông minh xung quanh hoạt động
                    mạng gián đoạn nhằm nỗ lực cung cấp 100% thời gian hoạt động
                    và kết nối hiệu suất cao trong tất cả các POP trên toàn thế
                    giới của chúng tôi.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="rts-hosting-faq section__padding">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="rts-section text-center">
                <h2
                  className="rts-section__title mb-0 sal-animate"
                  data-sal="slide-down"
                  data-sal-delay={100}
                  data-sal-duration={800}
                >
                  Chi tiết SLA
                </h2>
              </div>
              <div
                className="rts-faq__accordion sal-animate"
                data-sal="slide-down"
                data-sal-delay={100}
                data-sal-duration={800}
              >
                <div className="accordion accordion-flush" id="rts-accordion">
                  <div className="accordion-item active">
                    <div className="accordion-header" id="first">
                      <h4
                        className="accordion-button collapse show"
                        data-bs-toggle="collapse"
                        data-bs-target="#item__one"
                        aria-expanded="false"
                        aria-controls="item__one"
                      >
                        Khái niệm thời gian gián đoạn?
                      </h4>
                    </div>
                    <div
                      id="item__one"
                      className="accordion-collapse collapse collapse show"
                      aria-labelledby="first"
                      data-bs-parent="#rts-accordion"
                    >
                      <div className="accordion-body">
                        Là số phút sẵn dùng tối đa mà không có kết nối đến lớp
                        ảo hóa và được tính cộng dồn trong một tháng dương lịch.
                        Thời gian gián đoạn không bao gồm phần Thời gian gián
                        đoạn có kế hoạch.
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <div className="accordion-header" id="two">
                      <h4
                        className="accordion-button collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target="#item__two"
                        aria-expanded="false"
                        aria-controls="item__two"
                      >
                        Khái niệm thời gian gián đoạn có kế hoạch?
                      </h4>
                    </div>
                    <div
                      id="item__two"
                      className="accordion-collapse collapse"
                      aria-labelledby="two"
                      data-bs-parent="#rts-accordion"
                    >
                      <div className="accordion-body">
                        Là các khoảng Thời gian gián đoạn liên quan tới mạng,
                        phần cứng, bảo trì, nâng cấp dịch vụ hoặc theo yêu cầu
                        của cơ quan nhà nước. Chúng tôi sẽ công bố hoặc thông
                        báo tới Khách hàng ít nhất ba (03) ngày hoặc 48 tiếng
                        trong trường hợp khẩn cấp trước khi tiến hành những hoạt
                        động nêu trên.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="rts-domain-pricing-area area-2 pt--120 pb--120">
        <div className="container">
          <div className="row justify-content-center">
            <div className="section-title-area w-550">
              <h2 className="section-title">
                Nội dung cam kết <br /> chất lượng
              </h2>
              <p className="desc">
                Trường hợp tỷ lệ hoạt động hàng tháng của máy chủ ảo giảm xuống
                dưới 99,9%, chúng tôi sẽ khấu trừ số tiền được tính theo tỷ lệ
                hiển thị bên dưới cho chi phí sử dụng trong tháng xảy ra sự cố.
              </p>
            </div>
          </div>
          <div className="section-inner">
            <div className="pricing-table-area">
              {/* PRICING PLAN */}
              <div className="tab__content open" id="all">
                <table className="table table-hover table-responsive">
                  <thead className="heading__bg">
                    <tr>
                      <th className="cell">Thời gian uptime hàng tháng</th>
                      <th className="cell">
                        Thời gian ở trạng thái không sẵn sàng
                      </th>
                      <th className="cell">Mức phí đền bù</th>
                    </tr>
                  </thead>
                  <tbody className="table__content">
                    <tr>
                      <td className="package">Từ 99,9% tới 100%</td>
                      <td className="process">Tối đa 43 phút</td>
                      <td className="ram">0%</td>
                    </tr>
                    <tr>
                      <td className="package">Từ 99% tới ít hơn 99,9%</td>
                      <td className="process">Tối đa 430 phút</td>
                      <td className="ram">30%</td>
                    </tr>
                    <tr>
                      <td className="package">Từ 90% tới ít hơn 99%</td>
                      <td className="process">Tối đa 4300 phút</td>
                      <td className="ram">50%</td>
                    </tr>
                    <tr>
                      <td className="package">Ít hơn 90%</td>
                      <td className="process">Hơn 4300 phút</td>
                      <td className="ram">100%</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
